/**
 * 安全跳转：登录成功后回到「被拦截前想去的页面」。
 * 只接受站内绝对路径（以 / 开头且不是 //host），避免开放重定向。
 */
export function safeRedirectTarget(state: unknown, fallback = '/home'): string {
  if (typeof state !== 'object' || state === null) return fallback;
  const from = (state as { from?: unknown }).from;
  if (typeof from !== 'string' || from.length === 0) return fallback;
  if (!from.startsWith('/') || from.startsWith('//')) return fallback;
  return from;
}